import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-master-plugin',
  templateUrl: './master-plugin.component.html',
  styleUrls: ['./master-plugin.component.scss']
})
export class MasterPluginComponent implements OnInit {

  constructor() { }

  initialWindow = true;
  secondWindow = false;
  thirdWindow = false;

  categoryToShow: any;
  pluginConfigurationsToShow: any;
  configPayload: {};

  categories = [
    // {
    //   'category' : 'Analytics-monitoring',
    //   'subCategories' : [
    //     {
    //       'subCategory' : 'Datadog'
    //     },
    //     {
    //       'subCategory' : 'Prometheus'
    //     },
    //     {
    //       'subCategory' : 'Zipkin'
    //     }
    //   ]
    // },
    {
      'category' : 'Authentication',
      'subCategories' : [
        {
          'subCategory' : 'Basic Auth'
        },
        {
          'subCategory' : 'Ldap Auth'
        },
        {
          'subCategory' : 'KeyAuth'
        },
        {
          'subCategory' : 'Oauth2'
        },
        {
          'subCategory' : 'Hmac Auth'
        },
        {
          'subCategory' : 'Jwt'
        }
      ]
    },
    {
      'category' : 'Security',
      'subCategories' : [
        {
          'subCategory' : 'ACL'
        },
        {
          'subCategory' : 'CORS'
        },
        {
          'subCategory' : 'Ip Restriction'
        },
        {
          'subCategory' : 'Bot Detection'
        }
      ]
    },
    {
      'category' : 'Serverless',
      'subCategories' : [
        {
          'subCategory' : 'AWS Lambda'
        },
        {
          'subCategory' : 'Pre Function'
        },
        {
          'subCategory' : 'Post Function'
        },
        {
          'subCategory' : 'Azure Function'
        }
      ]
    },
    {
      'category' : 'Traffic-control',
      'subCategories' : [
        {
          'subCategory' : 'Rate limiting'
        },
        {
           'subCategory' : 'Request size limiting'
        },
        {
          'subCategory' : 'Request Termination'
        }
        // {
        //   'subCategory' : 'Response Rate Limiting'
        // }
      ]
    }
  ];

  masterPluginData = [
    {
      'category': [
        // {
        //   'CategoryName': 'Analytics-monitoring',
        //   'tagline': 'Analytics & Monitoring',
        //   'gliphyicon': 'glyphticon',
        //   'pluginsInTheCategory': [
        //     {
        //       'displayName': 'Zipkin',
        //       'name': 'zipkin',
        //       'isConfigured': false,
        //       'img': '/assets/img/zipkin.png',
        //       'description': 'Configure Zipkin service.',
        //         'tagline': 'Propagate Zipkin distributed tracing spans, and report spans to a Zipkin server',
        //       'config': [
        //         {
        //           'displayName': 'HTTP Endpoint',
        //           'parameter': 'http_endpoint',
        //           'type': 'string',
        //           'value': null,
        //           'isRequired': true,
        //           'description': 'The full HTTP(S) endpoint to which Zipkin spans should be sent by Kong. If not specified, the Zipkin plugin will only act as a tracing header generator/transmitter.'
        //         },
        //         // {
        //         //   'displayName': 'Static Tags',
        //         //   'parameter': 'static_tags',
        //         //   'type': 'array_string',
        //         //   'value': '',
        //         //   'isRequired': false,
        //         //   'description': 'The tags specified on this property will be added to the generated request traces. For example: [ { "name": "color", "value": "red" } ]'
        //         // },
        //         {
        //           'displayName': 'Sample Ratio',
        //           'parameter': 'sample_ratio',
        //           'type': 'number',
        //           'value': 0.001,
        //           'isRequired': false,
        //           'description': 'How often to sample requests that do not contain trace ids. Set to 0 to turn sampling off, or to 1 to sample all requests. The value must be between zero (0) and one (1), inclusive.'
        //         },
        //         {
        //           'displayName': 'Default Service Name',
        //           'parameter': 'default_service_name',
        //           'type': 'string',
        //           'value': null,
        //           'description': ''
        //         },
        //         {
        //           'displayName': 'Include Credential',
        //           'parameter': 'include_credential',
        //           'type': 'boolean',
        //           'value': true,
        //             'isRequired': true,
        //             'description': 'Should the credential of the currently authenticated consumer be included in metadata sent to the Zipkin server?'
        //         },
        //           {
        //               'displayName': 'Trace ID Byte Count',
        //               'parameter': 'traceid_byte_count',
        //               'type': 'number',
        //               'value': 16,
        //               'isRequired': true,
        //               'description': 'The length in bytes of each request’s Trace ID. The value can be either 8 or 16.'
        //           },
        //           {
        //               'displayName': 'Header Type',
        //               'parameter': 'header_type',
        //               'type': 'string',
        //               'value': 'preserve',
        //               'isRequired': true,
        //               'description': 'All HTTP requests going through the plugin will be tagged with a tracing HTTP request. This property codifies what kind of tracing header the plugin expects on incoming requests. Possible values are b3, b3-single, w3c, preserve, jaeger, or ot. The b3 option means that the plugin expects Zipkin’s B3 multiple headers on incoming requests, and will add them to the transmitted requests if they are missing from it. The b3-single option expects or adds Zipkin’s B3 single-header tracing headers. The w3c option expects or adds W3C’s traceparent tracing header. The preserve option does not expect any format, and will transmit whatever header is recognized or present, with a default of b3 if none is found. In case of a mismatch between the expected and incoming tracing headers (for example, when header_type is set to b3 but a w3c-style tracing header is found in the incoming request), then the plugin will add both kinds of tracing headers to the request and generate a mismatch warning in the logs. jaeger will use and expect Jaeger-style tracing headers (uber-trace-id). The ot option is for OpenTelemetry tracing headers of the form ot-tracer-*.'
        //           },
        //           {
        //               'displayName': 'Default Header Type',
        //               'parameter': 'default_header_type',
        //               'type': 'string',
        //               'value': 'b3',
        //               'isRequired': true,
        //               'description': 'Allows specifying the type of header to be added to requests with no pre-existing tracing headers and when config.header_type is set to "preserve". When header_type is set to any other value, default_header_type is ignored. Possible values are b3, b3-single, w3c, jaeger, or ot.'
        //           },
        //           {
        //               'displayName': 'Tags Headers',
        //               'parameter': 'tags_header',
        //               'type': 'string',
        //               'value': 'Zipkin-Tags',
        //               'isRequired': true,
        //               'description': 'The Zipkin plugin will add extra headers to the tags associated with any HTTP requests that come with a header named as configured by this property. The format is name_of_tag=value_of_tag, separated by commas. For example: with the default value, a request with the header Zipkin-Tags: fg=blue, bg=red will generate a trace with the tag fg with value blue, and another tag called bg with value red.'
        //           }
        //       ]
        //     },
        //     {
        //       'displayName': 'Datadog',
        //       'name': 'datadog',
        //       'isConfigured': false,
        //       'img': '/assets/img/datadog.png',
        //       'description': 'Configure Datadog service.',
        //       'tagline': 'Visualize API metrics on Datadog',
        //       'config': [
        //
        //         {
        //           'displayName': 'Host',
        //           'parameter': 'host',
        //           'type': 'string',
        //           'value': '127.0.0.1',
        //           'isRequired': true,
        //           'description': 'The IP address or host name to send data to'
        //         },
        //         {
        //           'displayName': 'Port',
        //           'parameter': 'port',
        //           'type': 'number',
        //           'value': 8125,
        //             'isRequired': true,
        //             'description': 'The port to send data to on the upstream server'
        //         },
        //         {
        //           'displayName': 'Prefix',
        //           'parameter': 'prefix',
        //           'type': 'string',
        //           'value': 'apiplatform',
        //             'isRequired': true,
        //             'description': 'String to be attached as prefix to metric’s name'
        //         }
        //       ]
        //     },
        //     {
        //       'displayName': 'Prometheus',
        //       'name': 'prometheus',
        //       'isConfigured': false,
        //       'img': 'assets/img/prometheus.png',
        //       'description': 'Configure Prometheus service.',
        //         'tagline': 'Expose metrics related to Kong and proxied Upstream services in Prometheus exposition format, which can be scraped by a Prometheus Server',
        //       'config': [
        //         // {
        //         //   'parameter': 'consumerID',
        //         //   'type': 'string',
        //         //   'value': '',
        //         //   'description': 'The CONSUMER ID that this plugin configuration will target. This value can only be used if authentication has been enabled so that the system can identify the user making the request. If left blank, the plugin will be applied to all consumers.'
        //         // }
        //       ]
        //     }
        //   ]
        // },
        {
          'CategoryName': 'Authentication',
          'tagline': 'Authentication',
          'gliphyicon': 'glyphticon',
          'pluginsInTheCategory': [
            {
              'displayName': 'Basic Auth',
              'name': 'basic-auth',
              'isConfigured': false,
              'img': '/assets/img/basic-auth.png',
              'description': 'Configure Basic Auth service.',
                'tagline': 'Add Basic Authentication to a Service or a Route with username and password protection. The plugin will check for valid credentials in the Proxy-Authorization and Authorization header (in that order)',
              'config': [
                // {
                //   'parameter': 'consumerID',
                //   'type': 'string',
                //   'value': '',
                //   'description': 'The CONSUMER ID that this plugin configuration will target. This value can only be used if authentication has been enabled so that the system can identify the user making the request. If left blank, the plugin will be applied to all consumers.'
                // },
                // {
                //   'displayName': 'Anonymous',
                //   'parameter': 'anonymous',
                //   'type': 'string',
                //   'value': '',
                //     'isRequired': false,
                //   'description': 'An optional string (consumer uuid) value to use as an “anonymous” consumer if authentication fails. If empty (default), the request will fail with an authentication failure 4xx. Please note that this value must refer to the Consumer id attribute which is internal to Kong, and not its custom_id'
                // },
                {
                  'displayName': 'Hide Credentials',
                  'parameter': 'hide_credentials',
                  'type': 'boolean',
                  'value': false,
                    'isRequired': false,
                  'description': 'An optional boolean value telling the plugin to show or hide the credential from the upstream service. If true, the plugin will strip the credential from the request (i.e. the Authorization header) before proxying it'
                }
              ]
            },
            {
              'displayName': 'Ldap Auth',
              'name': 'ldap-auth',
              'isConfigured': false,
              'img': 'assets/img/ldap-auth.png',
              'description': 'Configure Ldap Auth service.',
              'tagline': 'Add LDAP Bind Authentication to a Route with username and password protection. The plugin checks for valid credentials in the Proxy-Authorization and Authorization headers (in that order)',
              'config': [
                // {
                //   'parameter': 'consumerID',
                //   'type': 'string',
                //   'value': '',
                //   'description': 'The CONSUMER ID that this plugin configuration will target. This value can only be used if authentication has been enabled so that the system can identify the user making the request. If left blank, the plugin will be applied to all consumers.'
                // },
                {
                  'displayName': 'Header Type',
                  'parameter': 'header_type',
                  'type': 'string',
                  'value': 'ldap',
                    'isRequired': false,
                    'description': 'An optional string to use as part of the Authorization header. By default, a valid Authorization header looks like this: Authorization: ldap base64(username:password). If header_type is set to “basic”, then the Authorization header would be Authorization: basic base64(username:password). Note that header_type can take any string, not just "ldap" and "basic"'
                },
                {
                  'displayName': 'LDAP Host',
                  'parameter': 'ldap_host',
                  'type': 'string',
                  'value': '',
                    'isRequired': true,
                  'description': 'Host on which the LDAP server is running'
                },
                {
                  'displayName': 'LDAP Port',
                  'parameter': 'ldap_port',
                  'type': 'number',
                  'value': 389,
                    'isRequired': true,
                  'description': 'TCP port where the LDAP server is listening. 389 is the default port for non-SSL LDAP and AD. 636 is the port required for SSL LDAP and AD. If ldaps is configured, you must use port 636'
                },
                {
                  'displayName': 'Start TLS',
                  'parameter': 'start_tls',
                  'type': 'boolean',
                  'value': false,
                    'isRequired': true,
                    'description': 'Set it to true to issue StartTLS (Transport Layer Security) extended operation over ldap connection. If the start_tls setting is enabled, ensure the ldaps setting is disabled'
                },
                {
                  'displayName': 'Verify LDAP Host',
                  'parameter': 'verify_ldap_host',
                  'type': 'boolean',
                  'value': false,
                    'isRequired': true,
                    'description': 'Set to true to authenticate LDAP server. The server certificate will be verified according to the CA certificates specified by the lua_ssl_trusted_certificate directive'
                },
                {
                  'displayName': 'Base DN',
                  'parameter': 'base_dn',
                  'type': 'string',
                  'value': '',
                    'isRequired': true,
                    'description': 'Base DN as the starting point for the search; e.g., “dc=example,dc=com”'
                },
                {
                  'displayName': 'Attribute',
                  'parameter': 'attribute',
                  'type': 'string',
                  'value': '',
                    'isRequired': true,
                    'description': 'Attribute to be used to search the user; e.g., “cn”'
                },
                {
                  'displayName': 'Cache TTL',
                  'parameter': 'cache_ttl',
                  'type': 'number',
                  'value': 60,
                    'isRequired': true,
                    'description': 'Cache expiry time in seconds'
                },
                {
                  'displayName': 'Hide Credentials',
                  'parameter': 'hide_credentials',
                  'type': 'boolean',
                  'value': false,
                    'isRequired': true,
                  'description': 'An optional boolean value telling the plugin to hide the credential to the upstream server. It will be removed by Kong before proxying the request'
                },
                {
                  'displayName': 'Timeout',
                  'parameter': 'timeout',
                  'type': 'number',
                  'value': 10000,
                    'isRequired': false,
                    'description': 'An optional timeout in milliseconds when waiting for connection with LDAP server'
                },
                {
                  'displayName': 'Keep Alive',
                  'parameter': 'keepalive',
                  'type': 'number',
                  'value': 60000,
                    'isRequired': false,
                    'description': 'An optional value in milliseconds that defines how long an idle connection to LDAP server will live before being closed'
                },
                // {
                //   'displayName': 'Anonymous',
                //   'parameter': 'anonymous',
                //   'type': 'string',
                //   'value': '',
                //     'isRequired': false,
                //     'description': 'An optional string (consumer UUID) value to use as an “anonymous” consumer if authentication fails. If empty (default), the request will fail with an authentication failure 4xx.\n' +
                //       '\n' +
                //       'Note: The value must refer to the Consumer id attribute that is internal to Kong, not its custom_id.'
                // },
                  {
                      'displayName': 'LDAPs',
                      'parameter': 'ldaps',
                      'type': 'boolean',
                      'value': false,
                      'isRequired': true,
                      'description': 'Set to true to connect using the LDAPS protocol (LDAP over TLS). When ldaps is configured, you must use port 636. If the ldap setting is enabled, ensure the start_tls setting is disabled'
                  }
              ]
            },
            {
              'displayName': 'Hmac Auth',
              'name': 'hmac-auth',
              'isConfigured': false,
              'img': '/assets/img/hmac-auth.png',
              'description': 'Configure Hmac Auth service.',
              'tagline': 'Add HMAC Signature authentication to a Service or a Route to establish the integrity of incoming requests. The plugin validates the digital signature sent in the Proxy-Authorization or Authorization header (in that order). This plugin implementation is based off the draft-cavage-http-signatures draft with a slightly different signature scheme',
              'config': [
                // {
                //   'parameter': 'consumerID',
                //   'type': 'string',
                //   'value': '',
                //   'description': 'The CONSUMER ID that this plugin configuration will target. This value can only be used if authentication has been enabled so that the system can identify the user making the request. If left blank, the plugin will be applied to all consumers.'
                // },
                // {
                //   'displayName': 'Anonymous',
                //   'parameter': 'anonymous',
                //   'type': 'string',
                //   'value': '',
                //     'isRequired': false,
                //     'description': 'An optional string (consumer UUID) value to use as an anonymous consumer if authentication fails. If empty (default), the request fails with an authentication failure 4xx. Please note that this value must refer to the Consumer id attribute which is internal to Kong, and not its custom_id'
                // },
                {
                  'displayName': 'Hide Credentials',
                  'parameter': 'hide_credentials',
                  'type': 'boolean',
                  'value': false,
                    'isRequired': false,
                  'description': 'An optional boolean value telling the plugin to show or hide the credential from the upstream service. If true, the plugin strips the credential from the request (i.e. the Authorization header) before proxying it'
                },
                {
                  'displayName': 'Clock Skew',
                  'parameter': 'clock_skew',
                  'type': 'number',
                  'value': 300,
                    'isRequired': false,
                    'description': 'Clock Skew in seconds to prevent replay attacks'
                },
                {
                  'displayName': 'Validate Request Body',
                  'parameter': 'validate_request_body',
                  'type': 'boolean',
                  'value': false,
                    'isRequired': true,
                    'description': 'A boolean value telling the plugin to enable body validation'
                },
                {
                  'displayName': 'Enforce Headers',
                  'parameter': 'enforce_headers',
                  'type': 'array_string',
                  'value': '',
                    'isRequired': true,
                    'description': 'Tip: List of comma separated values. A list of headers that the client should at least use for HTTP signature creation.'
                },
                {
                  'displayName': 'Algorithms',
                  'parameter': 'algorithms',
                  'type': 'array_string',
                  'value': '',
                    'isRequired': true,
                    'description': 'Tip: List of comma separated values. A list of HMAC digest algorithms that the user wants to support. Allowed values are hmac-sha1, hmac-sha256, hmac-sha384, and hmac-sha512'
                }
              ]
            },
            {
              'displayName': 'Jwt',
              'name': 'jwt',
              'isConfigured': false,
              'img': '/assets/img/jwt.png',
              'description': 'Configure Jwt service.',
                'tagline': 'Verify requests containing HS256 or RS256 signed JSON Web Tokens (as specified in RFC 7519). Each of your Consumers will have JWT credentials (public and secret keys), which must be used to sign their JWTs',
              'config': [
                // {
                //   'displayName': 'Anonymous',
                //   'parameter': 'anonymous',
                //   'type': 'string',
                //   'value': '',
                //     'isRequired': false,
                //     'description': 'An optional string (consumer uuid) value to use as an anonymous consumer if authentication fails. If empty (default), the request will fail with an authentication failure 4xx. The anonymous value must refer to the Consumer id attribute that is internal to Kong, and not its custom_id'
                // },
                {
                  'displayName': 'URI Param Names',
                  'parameter': 'uri_param_names',
                  'type': 'array_string',
                  'value': 'jwt',
                    'isRequired': false,
                  'description': 'A list of querystring parameters that Kong will inspect to retrieve JWTs'
                },
                {
                  'displayName': 'Cookie Names',
                  'parameter': 'cookie_names',
                  'type': 'array_string',
                  'value': 'UID',
                    'isRequired': false,
                    'description': 'A list of cookie names that Kong will inspect to retrieve JWTs'
                },
                {
                  'displayName': 'Key Claim Name',
                  'parameter': 'key_claim_name',
                  'type': 'string',
                  'value': 'iss',
                    'isRequired': false,
                    'description': 'The name of the claim in which the key identifying the secret must be passed. Starting with version 0.13.1, the plugin will attempt to read this claim from the JWT payload and the header, in that order'
                },
                {
                  'displayName': 'Secret Is Base64',
                  'parameter': 'secret_is_base64',
                  'type': 'boolean',
                  'value': false,
                    'isRequired': true,
                    'description': 'If true, the plugin assumes the credential’s secret to be base64 encoded. You will need to create a base64-encoded secret for your Consumer, and sign your JWT with the original secret'
                },
                {
                  'displayName': 'Claims To Verify',
                  'parameter': 'claims_to_verify',
                  'type': 'array_string',
                  'value': 'exp',
                    'isRequired': false,
                    'description': 'A list of registered claims (according to RFC 7519) that Kong can verify as well. Accepted values: one of exp or nbf'
                },
                {
                  'displayName': 'Run On Preflight',
                  'parameter': 'run_on_preflight',
                  'type': 'boolean',
                  'value': true,
                    'isRequired': true,
                    'description': 'A boolean value that indicates whether the plugin should run (and try to authenticate) on OPTIONS preflight requests. If set to false, then OPTIONS requests will always be allowed'
                },
                {
                  'displayName': 'Maximum Expiration',
                  'parameter': 'maximum_expiration',
                  'type': 'number',
                  'value': 0,
                    'isRequired': false,
                    'description': 'A value between 0 and 31536000 (365 days) limiting the lifetime of the JWT to maximum_expiration seconds in the future. Any JWT that has a longer lifetime is rejected (HTTP 403). If this value is specified, exp must be specified as well in the claims_to_verify property. The default value of 0 represents an indefinite period. Potential clock skew should be considered when configuring this setting'
                },
                {
                  'displayName': 'Header Names',
                  'parameter': 'header_names',
                  'type': 'array_string',
                  'value': 'authorization',
                    'isRequired': false,
                    'description': 'A list of HTTP header names that Kong will inspect to retrieve JWTs'
                }
              ],
            },
            // {
            //   'displayName': 'Oauth2',
            //   'name': 'oauth2',
            //   'isConfigured': false,
            //   'img': 'assets/img/oauth2.png',
            //   'description': 'Configure Oauth2 service.',
            //   'tagline': 'Add an OAuth 2.0 authentication layer with the Authorization Code Grant, Client Credentials, Implicit Grant, or Resource Owner Password Credentials Grant flow',
            //   'config': [
            //     // {
            //     //   'parameter': 'consumerID',
            //     //   'type': 'string',
            //     //   'value': '',
            //     //   'description': 'The CONSUMER ID that this plugin configuration will target. This value can only be used if authentication has been enabled so that the system can identify the user making the request. If left blank, the plugin will be applied to all consumers.'
            //     // },
            //     {
            //       'displayName': 'Scopes',
            //       'parameter': 'scopes',
            //       'type': 'array_string',
            //       'value': '',
            //         'isRequired': true,
            //       'description': 'Describes an array of scope names that will be available to the end user. If mandatory_scope is set to true, then scopes are required'
            //     },
            //     {
            //       'displayName': 'Mandatory Scope',
            //       'parameter': 'mandatory_scope',
            //       'type': 'boolean',
            //       'value': false,
            //         'isRequired': true,
            //         'description': 'A boolean value telling the plugin to require at least one scope to be authorized by the end user'
            //     },
            //     {
            //       'displayName': 'Token Expiration',
            //       'parameter': 'token_expiration',
            //       'type': 'number',
            //       'value': 7200,
            //         'isRequired': true,
            //       'description': 'An integer value telling the plugin how many seconds a token should last, after which the client will need to refresh the token. Set to 0 to disable the expiration'
            //     },
            //     {
            //       'displayName': 'Enable Authorization Code',
            //       'parameter': 'enable_authorization_code',
            //       'type': 'boolean',
            //       'value': false,
            //         'isRequired': true,
            //         'description': 'A boolean value to enable the three-legged Authorization Code flow (RFC 6742 Section 4.1)'
            //     },
            //     {
            //       'displayName': 'Enable Implicit Grant',
            //       'parameter': 'enable_implicit_grant',
            //       'type': 'boolean',
            //       'value': true,
            //         'isRequired': true,
            //         'description': 'An boolean value to enable the Implicit Grant flow which allows to provision a token as a result of the authorization process (RFC 6742 Section 4.2)'
            //     },
            //     {
            //       'displayName': 'Enable Client Credentials',
            //       'parameter': 'enable_client_credentials',
            //       'type': 'boolean',
            //       'value': false,
            //         'isRequired': true,
            //         'description': 'A boolean value to enable the Client Credentials Grant flow (RFC 6742 Section 4.4)'
            //     },
            //     {
            //       'displayName': 'Enable Password Grant',
            //       'parameter': 'enable_password_grant',
            //       'type': 'boolean',
            //       'value': false,
            //         'isRequired': true,
            //         'description': 'An boolean value to enable the Resource Owner Password Credentials Grant flow (RFC 6742 Section 4.3)'
            //     },
            //     {
            //       'displayName': 'Hide Credentials',
            //       'parameter': 'hide_credentials',
            //       'type': 'boolean',
            //       'value': false,
            //         'isRequired': false,
            //         'description': 'An optional boolean value telling the plugin to show or hide the credential from the upstream service. If true, the plugin will strip the credential from the request (the header containing the client credentials) before proxying it'
            //     },
            //       {
            //           'displayName': 'Accept HTTP if already terminated',
            //           'parameter': 'accept_http_if_already_terminated',
            //           'type': 'boolean',
            //           'value': false,
            //           'isRequired': false,
            //           'description': 'Accepts HTTPs requests that have already been terminated by a proxy or load balancer and the x-forwarded-proto: https header has been added to the request. Only enable this option if the Kong server cannot be publicly accessed and the only entry point is such proxy or load balancer'
            //       },
            //     // {
            //     //   'displayName': 'Anonymous',
            //     //   'parameter': 'anonymous',
            //     //   'type': 'string',
            //     //   'value': '',
            //     //     'isRequired': false,
            //     //     'description': 'An optional string (consumer uuid) value to use as an “anonymous” consumer if authentication fails. If empty (default), the request will fail with an authentication failure 4xx. Please note that this value must refer to the Consumer id attribute which is internal to Kong, and not its custom_id'
            //     // },
            //     {
            //       'displayName': 'Global Credentials',
            //       'parameter': 'global_credentials',
            //       'type': 'boolean',
            //       'value': false,
            //         'isRequired': true,
            //         'description': 'An optional boolean value that allows using the same OAuth credentials generated by the plugin with any other Service whose OAuth 2.0 plugin configuration also has config.global_credentials=true'
            //     },
            //     {
            //       'displayName': 'Auth Header Name',
            //       'parameter': 'auth_header_name',
            //       'type': 'string',
            //       'value': 'authorization',
            //         'isRequired': false,
            //       'description': 'The name of the header that is supposed to carry the access token. Default: authorization'
            //     },
            //     {
            //       'displayName': 'Refresh Token TTL',
            //       'parameter': 'refresh_token_ttl',
            //       'type': 'number',
            //       'value': 1209600,
            //         'isRequired': true,
            //         'description': 'An optional integer value telling the plugin how many seconds a token/refresh token pair is valid for, and can be used to generate a new access token. Default value is 2 weeks. Set to 0 to keep the token/refresh token pair valid indefinitely'
            //     },
            //       {
            //           'displayName': 'Provision Key',
            //           'parameter': 'provision_key',
            //           'type': 'string',
            //           'value': 'true',
            //           'isRequired': true,
            //           'description': 'The unique key the plugin has generated when it has been added to the Service'
            //       },
            //       {
            //           'displayName': 'Reuse Refresh Token',
            //           'parameter': 'reuse_refresh_token',
            //           'type': 'boolean',
            //           'value': false,
            //           'isRequired': true,
            //           'description': 'A boolean value that indicates whether an OAuth refresh token is reused when refreshing an access token'
            //       },
            //       // {
            //       //     'displayName': 'Persistent Refresh Token',
            //       //     'parameter': 'persistent_refresh_token',
            //       //     'type': 'boolean',
            //       //     'value': false,
            //       //     'isRequired': true,
            //       //     'description': 'An optional boolean value that indicates whether an OAuth refresh token is persisted when refreshing an access token'
            //       // },
            //       {
            //           'displayName': 'Proof key for Code Exchange',
            //           'parameter': 'pkce',
            //           'type': 'string',
            //           'value': 'lax',
            //           'isRequired': false,
            //           'description': 'Specifies a mode of how the Proof Key for Code Exchange (PKCE) should be handled by the plugin. The possible modes are none, lax, and strict. The strict mode enforces PKCE on both authorization and token endpoints for all the clients. The lax mode enforces PKCE for public clients, but it does not enforce it for confidential clients. The none mode does not enforce PKCE on any client. In any case, if a client asks for PKCE on authorization endpoint, the PKCE is also enforced on token endpoint'
            //       }
            //   ]
            // },
            {
              'displayName': 'KeyAuth',
              'name': 'key-auth',
              'isConfigured': false,
              'img': '/assets/img/key-auth.png',
              'description': 'Configure KeyAuth service..',
              'tagline' : 'Add Key Authentication (also referred to as an API key) to your APIs. Consumers then add their key either in a querystring parameter or a header to authenticate their requests',
              'config': [
                {
                  'displayName': 'Key Names',
                  'parameter': 'key_names',
                  'type': 'array_string',
                  'value': 'apikey',
                    'isRequired': true,
                  'description': 'Describes an array of parameter names where the plugin will look for a key. The client must send the authentication key in one of those key names, and the plugin will try to read the credential from a header, request body, or query string parameter with the same name.\n' +
                      'Note: The key names may only contain [a-z], [A-Z], [0-9], [_] underscore, and [-] hyphen'
                },
                {
                  'displayName': 'Key In Body',
                  'parameter': 'key_in_body',
                  'type': 'boolean',
                  'value': false,
                    'isRequired': false,
                    'description': 'If enabled, the plugin reads the request body (if said request has one and its MIME type is supported) and tries to find the key in it. Supported MIME types: application/www-form-urlencoded, application/json, and multipart/form-data'
                },
                {
                  'displayName': 'Hide Credentials',
                  'parameter': 'hide_credentials',
                  'type': 'boolean',
                  'value': false,
                    'isRequired': false,
                    'description': 'An optional boolean value telling the plugin to show or hide the credential from the upstream service. If true, the plugin strips the credential from the request (i.e., the header, query string, or request body containing the key) before proxying it'
                },
                {
                  'displayName': 'Run On Preflight',
                  'parameter': 'run_on_preflight',
                  'type': 'boolean',
                  'value': true,
                    'isRequired': false,
                    'description': 'A boolean value that indicates whether the plugin should run (and try to authenticate) on OPTIONS preflight requests. If set to false, then OPTIONS requests are always allowed'
                },
                // {
                //   'displayName': 'Anonymous',
                //   'parameter': 'anonymous',
                //   'type': 'string',
                //   'value': '',
                //     'isRequired': false,
                //     'description': 'An optional string (Consumer UUID) value to use as an anonymous Consumer if authentication fails. If empty (default), the request will fail with an authentication failure 4xx. Note that this value must refer to the Consumer id attribute that is internal to Kong, and not its custom_id'
                // },
                  {
                      'displayName': 'Key In Header',
                      'parameter': 'key_in_header',
                      'type': 'boolean',
                      'value': true,
                      'isRequired': false,
                      'description': 'If enabled (default), the plugin reads the request header and tries to find the key in it'
                  },
                  {
                      'displayName': 'Key In Query',
                      'parameter': 'key_in_query',
                      'type': 'boolean',
                      'value': true,
                      'isRequired': false,
                      'description': 'If enabled (default), the plugin reads the query parameter in the request and tries to find the key in it'
                  },
              ]
            }
          ]
        },
        {
          'CategoryName': 'Security',
          'tagline': 'Security',
          'gliphyicon': 'glyphticon',
          'pluginsInTheCategory': [
            {
              'displayName': 'ACL',
              'name': 'acl',
              'isConfigured': false,
              'img': '/assets/img/acl.png',
              'description': 'Configure ACL service.',
              'tagline': 'Restrict access to a Service or a Route by adding Consumers to allowed or denied lists using arbitrary ACL group names. This plugin requires an authentication plugin (such as Basic Authentication, Key Authentication, OAuth 2.0, and OpenID Connect) to have been already enabled on the Service or Route',
              'config': [
                // {
                //   'parameter': 'consumerID',
                //   'type': 'string',
                //   'value': '',
                //   'description': 'The CONSUMER ID that this plugin configuration will target. This value can only be used if authentication has been enabled so that the system can identify the user making the request. If left blank, the plugin will be applied to all consumers.'
                // },
                {
                  'displayName': 'Allow',
                  'parameter': 'allow',
                  'type': 'array_string',
                  'value': null,
                  'description': 'Tip: Comma separated list of arbitrary group names that are allowed to consume the API. At least one between whitelist or blacklist must be specified.'
                },
                {
                  'displayName': 'Deny',
                  'parameter': 'deny',
                  'type': 'array_string',
                  'value': null,
                  'description': 'Tip: Comma separated list of arbitrary group names that are not allowed to consume the API. At least one between whitelist or blacklist must be specified.'
                },
                {
                  'displayName': 'Hide Groups Header',
                  'parameter': 'hide_groups_header',
                  'type': 'boolean',
                  'value': false,
                    'isRequired': true,
                  'description': 'Flag that if enabled (true), prevents the X-Consumer-Groups header to be sent in the request to the Upstream service'
                }
              ]
            },
            {
              'displayName': 'CORS',
              'name': 'cors',
              'isConfigured': false,
              'img': 'assets/img/cors.png',
              'description': 'Configure CORS service.',
              'tagline': 'Allow developers to make requests from the browser. Easily add cross-origin resource sharing (CORS) to a Service and a Route by enabling this plugin',
              'config': [
                // {
                //   'parameter': 'consumerID',
                //   'type': 'string',
                //   'value': '',
                //   'description': 'The CONSUMER ID that this plugin configuration will target. This value can only be used if authentication has been enabled so that the system can identify the user making the request. If left blank, the plugin will be applied to all consumers.'
                // },
                {
                  'displayName': 'Origins',
                  'parameter': 'origins',
                  'type': 'array_string',
                  'value': '*',
                    'isRequired': false,
                  'description': 'List of allowed domains for the Access-Control-Allow-Origin header. If you want to allow all origins, add * as a single value to this configuration field. The accepted values can either be flat strings or PCRE regexes'
                },
                {
                  'displayName': 'Headers',
                  'parameter': 'headers',
                  'type': 'array_string',
                  'value': null,
                    'isRequired': false,
                    'description': 'Tip: Comma separated values for the Access-Control-Allow-Headers header, expects a comma delimited string (e.g. Origin, Authorization).'
                },
                {
                  'displayName': 'Exposed Headers',
                  'parameter': 'exposed_headers',
                  'type': 'array_string',
                  'value': null,
                    'isRequired': false,
                    'description': 'Tip: Comma separated values for the Access-Control-Expose-Headers header, expects a comma delimited string (e.g. Origin, Authorization). If not specified, no custom headers are exposed.'
                },
                {
                  'displayName': 'Methods',
                  'parameter': 'methods',
                  'type': 'array_string',
                  'value': null,
                    'isRequired': false,
                  'description': 'Value for the Access-Control-Allow-Methods header. Available options include GET, HEAD, PUT, PATCH, POST, DELETE, OPTIONS, TRACE, CONNECT. By default, all options are allowed'
                },
                {
                  'displayName': 'Max Age',
                  'parameter': 'max_age',
                  'type': 'number',
                  'value': 300,
                    'isRequired': false,
                  'description': 'Indicates how long the results of the preflight request can be cached, in seconds'
                },
                {
                  'displayName': 'Credentials',
                  'parameter': 'credentials',
                  'type': 'boolean',
                  'value': false,
                    'isRequired': true,
                    'description': 'Flag to determine whether the Access-Control-Allow-Credentials header should be sent with true as the value'
                },
                {
                  'displayName': 'Preflight Continue',
                  'parameter': 'preflight_continue',
                  'type': 'boolean',
                  'value': false,
                    'isRequired': true,
                    'description': 'A boolean value that instructs the plugin to proxy the OPTIONS preflight request to the Upstream service'
                }
              ]
            },
            {
              'displayName': 'Ip Restriction',
              'name': 'ip-restriction',
              'isConfigured': false,
              'img': 'assets/img/ip-restriction.png',
              'description': 'Configure IP Restriction service.',
              'tagline': 'Restrict access to a Service or a Route by either allowing or denying IP addresses. Single IPs, multiple IPs or ranges in CIDR notation like 10.10.10.0/24 can be used. The plugin supports IPv4 and IPv6 addresses',
              'config': [
                // {
                //   'parameter': 'consumerID',
                //   'type': 'string',
                //   'value': '',
                //   'description': 'The CONSUMER ID that this plugin configuration will target. This value can only be used if authentication has been enabled so that the system can identify the user making the request. If left blank, the plugin will be applied to all consumers.'
                // },
                {
                  'displayName': 'Allow',
                  'parameter': 'allow',
                  'type': 'array_string',
                  'value': '127.0.0.1',
                  'description': 'Tip: Comma separated list of IPs or CIDR ranges to whitelist. At least one between whitelist or blacklist must be specified.'
                },
                {
                  'displayName': 'Deny',
                  'parameter': 'deny',
                  'type': 'array_string',
                  'value': null,
                  'description': 'Tip: Comma separated list of IPs or CIDR ranges to blacklist. At least one between whitelist or blacklist must be specified.'
                }
              ]
            },
            {
              'displayName': 'Bot Detection',
              'name': 'bot-detection',
              'isConfigured': false,
              'img': 'assets/img/bot-detection.png',
              'description': 'Configure Bot detection service.',
              'tagline': 'Protects a Service or a Route from most common bots and has the capability of allowing and denying custom clients',
              'config': [
                // {
                //   'parameter': 'consumerID',
                //   'type': 'string',
                //   'value': '',
                //   'description': 'The CONSUMER ID that this plugin configuration will target. This value can only be used if authentication has been enabled so that the system can identify the user making the request. If left blank, the plugin will be applied to all consumers.'
                // },
                {
                  'displayName': 'Deny',
                  'parameter': 'deny',
                  'type': 'array_string',
                  'value': null,
                  'description': 'An array of regular expressions that should be allowed. The regular expressions will be checked against the User-Agent header'
                },
                {
                  'displayName': 'Allow',
                  'parameter': 'allow',
                  'type': 'array_string',
                  'value': null,
                  'description': 'An array of regular expressions that should be denied. The regular expressions will be checked against the User-Agent header'
                }
              ]
            }
          ]
        },
        {
          'CategoryName': 'Serverless',
          'tagline': 'Serverless',
          'gliphyicon': 'glyphticon',
          'pluginsInTheCategory': [
            {
              'displayName': 'AWS Lambda',
              'name': 'aws-lambda',
              'isConfigured': false,
              'img': '/assets/img/aws-lambda.png',
              'description': 'Configure AWS Lambda',
              'tagline': 'Invoke an AWS Lambda function from apiplatform.io . It can be used in combination with other request plugins to secure, manage or extend the function',
              'config': [
                // {
                //   'parameter': 'consumerID',
                //   'type': 'string',
                //   'value': '',
                //   'description': 'The CONSUMER ID that this plugin configuration will target. This value can only be used if authentication has been enabled so that the system can identify the user making the request. If left blank, the plugin will be applied to all consumers.'
                // },
                {
                  'displayName': 'Timeout',
                  'parameter': 'timeout',
                  'type': 'number',
                  'value': 60000,
                    'isRequired': true,
                    'description': 'A timeout in milliseconds when invoking the function'
                },
                {
                  'displayName': 'Keep Alive',
                  'parameter': 'keepalive',
                  'type': 'number',
                  'value': 60000,
                    'isRequired': true,
                    'description': 'An optional value in milliseconds that defines how long an idle connection lives before being closed'
                },
                {
                  'displayName': 'AWS Key',
                  'parameter': 'aws_key',
                  'type': 'string',
                  'value': null,
                    'isRequired': false,
                  'description': 'The AWS key credential to be used when invoking the function. The aws_key value is required if aws_secret is defined. If aws_key and aws_secret are not set, the plugin uses an IAM role inherited from the instance running Kong to authenticate. Can be symmetrically encrypted if using Kong Gateway (Enterprise) and data encryption is configured'
                },
                {
                  'displayName': 'AWS Secret',
                  'parameter': 'aws_secret',
                  'type': 'string',
                  'value': null,
                    'isRequired': false,
                    'description': 'The AWS secret credential to be used when invoking the function. The aws_secret value is required if aws_key is defined. If aws_key and aws_secret are not set, the plugin uses an IAM role inherited from the instance running Kong to authenticate. Can be symmetrically encrypted if using Kong Gateway (Enterprise) and data encryption is configured'
                },
                {
                  'displayName': 'AWS Region',
                  'parameter': 'aws_region',
                  'type': 'string',
                  'value': null,
                    'isRequired': false,
                    'description': 'The AWS region where the Lambda function is located. The plugin does not attempt to validate the supplied region name. If an invalid region name is provided, the plugin responds with an HTTP 500 Internal Server Error at run-time and logs a DNS resolution failure. Either aws_region or host must be provided'
                },
                {
                  'displayName': 'Function Name',
                  'parameter': 'function_name',
                  'type': 'string',
                  'value': '',
                    'isRequired': true,
                    'description': 'The AWS Lambda function name to invoke'
                },
                {
                  'displayName': 'Qualifier',
                  'parameter': 'qualifier',
                  'type': 'string',
                  'value': '',
                    'isRequired': false,
                    'description': 'The Qualifier to use when invoking the function'
                },
                {
                  'displayName': 'Invocation Type',
                  'parameter': 'invocation_type',
                  'type': 'string',
                  'value': 'RequestResponse',
                    'isRequired': true,
                    'description': 'The InvocationType to use when invoking the function. Available types are RequestResponse, Event, DryRun'
                },
                {
                  'displayName': 'Log Type',
                  'parameter': 'log_type',
                  'type': 'string',
                  'value': 'Tail',
                    'isRequired': true,
                    'description': 'The LogType to use when invoking the function. By default, None and Tail are supported'
                },
                {
                  'displayName': 'Unhandled Status',
                  'parameter': 'unhandled_status',
                  'type': 'number',
                  'value': 200,
                    'isRequired': false,
                    'description': 'The response status code to use (instead of the default 200, 202, or 204) in the case of an Unhandled Function Error'
                },
                {
                  'displayName': 'Port',
                  'parameter': 'port',
                  'type': 'number',
                  'value': 443,
                    'isRequired': false,
                  'description': 'The TCP port that the plugin uses to connect to the server'
                },
                {
                  'displayName': 'Forward Request Method',
                  'parameter': 'forward_request_method',
                  'type': 'boolean',
                  'value': false,
                    'isRequired': false,
                    'description': 'An optional value that defines whether the original HTTP request method verb is sent in the request_method field of the JSON-encoded request'
                },
                {
                  'displayName': 'Forward request URI',
                  'parameter': 'forward_request_uri',
                  'type': 'boolean',
                  'value': false,
                    'isRequired': false,
                    'description': 'An optional value that defines whether the original HTTP request URI is sent in the request_uri field of the JSON-encoded request. Request URI arguments (if any) are sent in the separate request_uri_args field of the JSON body'
                },
                {
                  'displayName': 'Forward Request Headers',
                  'parameter': 'forward_request_headers',
                  'type': 'boolean',
                  'value': false,
                    'isRequired': false,
                    'description': 'An optional value that defines whether the original HTTP request headers are sent as a map in the request_headers field of the JSON-encoded request'
                },
                {
                  'displayName': 'Forward Request Body',
                  'parameter': 'forward_request_body',
                  'type': 'boolean',
                  'value': false,
                    'isRequired': false,
                    'description': 'An optional value that defines whether the request body is sent in the request_body field of the JSON-encoded request. If the body arguments can be parsed, they are sent in the separate request_body_args field of the request. The body arguments can be parsed for application/json, application/x-www-form-urlencoded, and multipart/form-data content types'
                },
                {
                  'displayName': 'Is Proxy Integration',
                  'parameter': 'is_proxy_integration',
                  'type': 'boolean',
                  'value': false,
                    'isRequired': false,
                    'description': ''
                },
                {
                  'displayName': 'AWS Gateway Compatible',
                  'parameter': 'awsgateway_compatible',
                  'type': 'boolean',
                  'value': false,
                  'isRequired': false,
                  'description': 'An optional value that defines whether the plugin should wrap requests into the Amazon API gateway'
                },
                {
                    'displayName': 'Proxy URL',
                    'parameter': 'proxy_url',
                  'type': 'string',
                  'value': null,
                    'isRequired': false,
                    'description': 'An optional value that defines whether the plugin should connect through the given proxy server URL. The proxy_url value is required if proxy_scheme is defined'
                },
                {
                    'displayName': 'Proxy Scheme',
                    'parameter': 'proxy_scheme',
                  'type': 'string',
                  'value': null,
                    'isRequired': false,
                    'description': 'An optional value that defines which HTTP scheme to use for connecting through the proxy server. The supported schemes are http and https. The proxy_scheme value is required if proxy_url is defined'
                },
                {
                    'displayName': 'Skip Large Bodies',
                    'parameter': 'skip_large_bodies',
                  'type': 'boolean',
                  'value': true,
                    'isRequired': false,
                    'description': 'An optional value that defines whether Kong should send large bodies that are buffered to disk. Note that enabling this option will have an impact on system memory depending on the number of requests simultaneously in flight at any given point in time and on the maximum size of each request. Also this option blocks all requests being handled by the nginx workers. That could be tens of thousands of other transactions that are not being processed. For small I/O operations, such a delay would generally not be problematic. In cases where the body size is in the order of MB, such a delay would cause notable interruptions in request processing. Given all of the potential downsides resulting from enabling this option, consider increasing the client_body_buffer_size value instead'
                },
                  // {
                  //   'displayName': 'Base64 Encode Body',
                  //   'parameter': 'base64_encode_body',
                  //   'type': 'boolean',
                  //   'value': true,
                  //   'isRequired': false,
                  //   'description': 'An optional value that Base64-encodes the request body'
                  // }
              ]
            },
            {
              'displayName': 'Pre Function',
              'name': 'pre-function',
              'isConfigured': false,
              'img': '/assets/img/kong.png',
              'description': 'Configure functions.',
              'tagline': 'Dynamically run Lua code from apiplatform.io during access phase',
              'config': [
                // {
                //   'parameter': 'consumerID',
                //   'type': 'string',
                //   'value': '',
                //   'description': 'The CONSUMER ID that this plugin configuration will target. This value can only be used if authentication has been enabled so that the system can identify the user making the request. If left blank, the plugin will be applied to all consumers.'
                // },
                {
                  'displayName': 'Functions',
                  'parameter': 'functions',
                  'type': 'array_string',
                  'value': '',
                    'isRequired': false,
                  'description': 'Tip: List of comma separated values'
                },
                  // {
                  //     'displayName': 'Certificate',
                  //     'parameter': 'certificate',
                  //     'type': 'array_string',
                  //     'value': '',
                  //     'isRequired': false,
                  //     'description': 'Array of stringified Lua code to be cached and run in sequence during the certificate phase. Note: This only runs on global plugins'
                  // },
                  // {
                  //     'displayName': 'Rewrite',
                  //     'parameter': 'rewrite',
                  //     'type': 'array_string',
                  //     'value': '',
                  //     'isRequired': false,
                  //     'description': 'Array of stringified Lua code to be cached and run in sequence during the rewrite phase. Note: This only runs on global plugins'
                  // },
                  // {
                  //     'displayName': 'Header Filter',
                  //     'parameter': 'header_filter',
                  //     'type': 'array_string',
                  //     'value': '',
                  //     'isRequired': false,
                  //     'description': 'Array of stringified Lua code to be cached and run in sequence during the header_filter phase'
                  // },
                  // {
                  //     'displayName': 'Body Filter',
                  //     'parameter': 'body_filter',
                  //     'type': 'array_string',
                  //     'value': '',
                  //     'isRequired': false,
                  //     'description': 'Array of stringified Lua code to be cached and run in sequence during the body_filter phase'
                  // },
                  // {
                  //     'displayName': 'Log',
                  //     'parameter': 'log',
                  //     'type': 'array_string',
                  //     'value': '',
                  //     'isRequired': false,
                  //     'description': 'Array of stringified Lua code to be cached and run in sequence during the log phase'
                  // },
              ]
            },
            {
              'displayName': 'Post Function',
              'name': 'post-function',
              'isConfigured': false,
              'img': '/assets/img/kong.png',
              'description': 'Configure functions.',
              'tagline': 'Dynamically run Lua code from apiplatform.io during access phase.',
                'config': [
                    // {
                    //   'parameter': 'consumerID',
                    //   'type': 'string',
                    //   'value': '',
                    //   'description': 'The CONSUMER ID that this plugin configuration will target. This value can only be used if authentication has been enabled so that the system can identify the user making the request. If left blank, the plugin will be applied to all consumers.'
                    // },
                    {
                        'displayName': 'Functions',
                        'parameter': 'functions',
                        'type': 'array_string',
                        'value': '',
                        'isRequired': false,
                        'description': 'Tip: List of comma separated values'
                    },
                    // {
                    //     'displayName': 'Certificate',
                    //     'parameter': 'certificate',
                    //     'type': 'array_string',
                    //     'value': '',
                    //     'isRequired': false,
                    //     'description': 'Array of stringified Lua code to be cached and run in sequence during the certificate phase. Note: This only runs on global plugins'
                    // },
                    // {
                    //     'displayName': 'Rewrite',
                    //     'parameter': 'rewrite',
                    //     'type': 'array_string',
                    //     'value': '',
                    //     'isRequired': false,
                    //     'description': 'Array of stringified Lua code to be cached and run in sequence during the rewrite phase. Note: This only runs on global plugins'
                    // },
                    // {
                    //     'displayName': 'Header Filter',
                    //     'parameter': 'header_filter',
                    //     'type': 'array_string',
                    //     'value': '',
                    //     'isRequired': false,
                    //     'description': 'Array of stringified Lua code to be cached and run in sequence during the header_filter phase'
                    // },
                    // {
                    //     'displayName': 'Body Filter',
                    //     'parameter': 'body_filter',
                    //     'type': 'array_string',
                    //     'value': '',
                    //     'isRequired': false,
                    //     'description': 'Array of stringified Lua code to be cached and run in sequence during the body_filter phase'
                    // },
                    // {
                    //     'displayName': 'Log',
                    //     'parameter': 'log',
                    //     'type': 'array_string',
                    //     'value': '',
                    //     'isRequired': false,
                    //     'description': 'Array of stringified Lua code to be cached and run in sequence during the log phase'
                    // },
                ]
            },
            {
              'displayName': 'Azure Function',
              'name': 'azure-functions',
              'isConfigured': false,
              'img': '/assets/img/azure-functions.png',
              'description': 'Configure Azure function.',
              'tagline': 'This setting invokes Azure Functions. It can be used in combination with other request plugins to secure, manage or extend the function',
              'config': [
                // {
                //   'parameter': 'consumerID',
                //   'type': 'string',
                //   'value': '',
                //   'description': 'The CONSUMER ID that this plugin configuration will target. This value can only be used if authentication has been enabled so that the system can identify the user making the request. If left blank, the plugin will be applied to all consumers.'
                // },
                // {
                //   'parameter': 'run_on',
                //   'type': 'dropdown',
                //   'value': [
                //     'First'
                //   ],
                //   'description': 'Tip:List of comma separated values'
                // },
                {
                  'displayName': 'Timeout',
                  'parameter': 'timeout',
                  'type': 'number',
                  'value': 60000,
                    'isRequired': false,
                    'description': 'Timeout in milliseconds before closing a connection to the Azure Functions server'
                },
                {
                    'displayName': 'Keep Alive',
                  'parameter': 'keepalive',
                  'type': 'number',
                  'value': 60000,
                    'isRequired': false,
                    'description': 'Time in milliseconds during which an idle connection to the Azure Functions server lives before being closed'
                },
                {
                  'displayName': 'HTTPS',
                  'parameter': 'https',
                  'type': 'boolean',
                  'value': true,
                    'isRequired': false,
                    'description': 'Use of HTTPS to connect with the Azure Functions server'
                },
                {
                  'displayName': 'HTTPS Verify',
                  'parameter': 'https_verify',
                  'type': 'boolean',
                  'value': false,
                    'isRequired': false,
                    'description': 'Set to true to authenticate the Azure Functions server'
                },
                {
                  'displayName': 'API Key',
                  'parameter': 'apikey',
                  'type': 'string',
                  'value': '',
                    'isRequired': false,
                    'description': 'The apikey to access the Azure resources. If provided, it is injected as the x-functions-key header'
                },
                {
                  'displayName': 'Client ID',
                  'parameter': 'clientid',
                  'type': 'string',
                  'value': '',
                    'isRequired': true,
                    'description': 'The clientid to access the Azure resources. If provided, it is injected as the x-functions-clientid header'
                },
                {
                  'displayName': 'App Name',
                  'parameter': 'appname',
                  'type': 'string',
                  'value': '',
                    'isRequired': true,
                    'description': 'The Azure app name'
                },
                {
                  'displayName': 'Host Domain',
                  'parameter': 'hostdomain',
                  'type': 'string',
                  'value': 'azurewebsites.net',
                    'isRequired': true,
                    'description': 'The domain where the function resides'
                },
                {
                    'displayName': 'Route Prefix',
                  'parameter': 'routeprefix',
                  'type': 'string',
                  'value': '/api',
                    'isRequired': false,
                    'description': 'Route prefix to use'
                },
                {
                  'displayName': 'Function Name',
                  'parameter': 'functionname',
                  'type': 'string',
                  'value': '',
                    'isRequired': true,
                  'description': 'Name of the Azure function to invoke'
                }
              ]
            }
          ]
        },
        {
          'CategoryName': 'Traffic-control',
          'tagline': 'Traffic control',
          'gliphyicon': 'glyphyicon',
          'pluginsInTheCategory': [
            {
              'displayName': 'Rate limiting',
              'name': 'rate-limiting',
              'isConfigured': false,
              'img': '/assets/img/rate-limiting.png',
              'description': 'Configure Rate limiting service.',
              'tagline': 'Rate limit how many HTTP requests a developer can make in a given period of seconds, minutes, hours, days, months or years. If the API has no authentication layer, the Client IP address will be used, otherwise the Consumer will be used if an authentication plugin has been configured',
              'config': [
                {
                  'displayName': 'Second',
                  'parameter': 'second',
                  'type': 'number',
                  'value': null,
                    'isRequired': false,
                  'description': 'The number of HTTP requests that can be made per second'
                },
                {
                  'displayName': 'Minute',
                  'parameter': 'minute',
                  'type': 'number',
                  'value': 5,
                    'isRequired': false,
                    'description': 'The number of HTTP requests that can be made per minute'
                },
                {
                  'displayName': 'Hour',
                  'parameter': 'hour',
                  'type': 'number',
                  'value': null,
                    'isRequired': false,
                    'description': 'The number of HTTP requests that can be made per hour'
                },
                {
                  'displayName': 'Day',
                  'parameter': 'day',
                  'type': 'number',
                  'value': null,
                    'isRequired': false,
                    'description': 'The number of HTTP requests that can be made per day'
                },
                {
                  'displayName': 'Month',
                  'parameter': 'month',
                  'type': 'number',
                  'value': null,
                    'isRequired': false,
                    'description': 'The number of HTTP requests that can be made per month'
                },
                {
                  'displayName': 'Year',
                  'parameter': 'year',
                  'type': 'number',
                  'value': null,
                    'isRequired': false,
                    'description': 'The number of HTTP requests that can be made per year'
                },
                {
                  'displayName': 'Limit By',
                  'parameter': 'limit_by',
                  'type': 'string',
                  'value': 'consumer',
                    'isRequired': false,
                    'description': 'The entity that will be used when aggregating the limits: consumer, credential, ip, service, header, path. If the value for the entity chosen to aggregate the limit cannot be determined, the system will always fallback to ip. If value service is chosen, the service_id configuration must be provided. If value header is chosen, the header_name configuration must be provided. If value path is chosen, the path configuration must be provided'
                },
                {
                  'displayName': 'Policy',
                  'parameter': 'policy',
                  'type': 'string',
                  'value': 'local',
                    'isRequired': false,
                    'description': 'In DB-less and hybrid modes, the cluster config policy is not supported. For DB-less mode, use one of redis or local; for hybrid mode, use redis, or local for data planes only.\n' +
                      '\n' +
                      'In Konnect Cloud, the default policy is redis'
                },
                {
                  'displayName': 'Fault Tolerant',
                  'parameter': 'fault_tolerant',
                  'type': 'boolean',
                  'value': true,
                    'isRequired': false,
                    'description': 'A boolean value that determines if the requests should be proxied even if Kong has troubles connecting a third-party datastore. If true, requests will be proxied anyway, effectively disabling the rate-limiting function until the datastore is working again. If false, then the clients will see 500 errors'
                },
                {
                  'displayName': 'Hide Client Headers',
                  'parameter': 'hide_client_headers',
                  'type': 'boolean',
                  'value': false,
                    'isRequired': false,
                    'description': 'Optionally hide informative response headers'
                },
                {
                  'displayName': 'Redis Host',
                  'parameter': 'redis_host',
                  'type': 'string',
                  'value': 'localhost',
                    'isRequired': false,
                    'description': 'When using the redis policy, this property specifies the address to the Redis server'
                },
                {
                  'displayName': 'Redis Password',
                  'parameter': 'redis_password',
                  'type': 'string',
                  'value': '',
                    'isRequired': false,
                    'description': 'When using the redis policy, this property specifies the password to connect to the Redis server'
                },
                {
                  'displayName': 'Redis Port',
                  'parameter': 'redis_port',
                  'type': 'number',
                  'value': 6379,
                    'isRequired': false,
                    'description': 'When using the redis policy, this property specifies the port of the Redis server. By default is 6379'
                },
                {
                  'displayName': 'Redis Timeout',
                  'parameter': 'redis_timeout',
                  'type': 'number',
                  'value': 2000,
                    'isRequired': false,
                    'description': 'When using the redis policy, this property specifies the timeout in milliseconds of any command submitted to the Redis server'
                },
                {
                  'displayName': 'Redis Database',
                  'parameter': 'redis_database',
                  'type': 'number',
                  'value': 0,
                    'isRequired': false,
                    'description': 'When using the redis policy, this property specifies the Redis database to use'
                },
                // {
                //   'displayName': 'Header Name',
                //   'parameter': 'header_name',
                //   'type': 'string',
                //   'value': '',
                //     'isRequired': false,
                //     'description': 'Header name to be used if limit_by is set to header'
                // },
                // {
                //   'displayName': 'Path',
                //   'parameter': 'path',
                //   'type': 'string',
                //   'value': '',
                //   'isRequired': false,
                //   'description': 'Path to be used if limit_by is set to path'
                // },
              ]
            },
            {
              'displayName': 'Request size limiting',
              'name': 'request-size-limiting',
              'isConfigured': false,
              'img': '/assets/img/request-size-limiting.png',
              'description': 'Configure Request size limiting service.',
              'tagline': 'Block requests with bodies greater than a specific size',
              'config': [
                // {
                //   'parameter': 'consumerID',
                //   'type': 'string',
                //   'value': '',
                //   'description': 'The CONSUMER ID that this plugin configuration will target. This value can only be used if authentication has been enabled so that the system can identify the user making the request. If left blank, the plugin will be applied to all consumers.'
                // },
                {
                  'displayName': 'Allowed Payload Size',
                  'parameter': 'allowed_payload_size',
                  'type': 'number',
                  'value': 128,
                    'isRequired': true,
                  'description': 'Allowed request payload size in megabytes, default is 128 (128000000 Bytes)'
                },
                {
                    'displayName': 'Size Unit',
                  'parameter': 'size_unit',
                  'type': 'string',
                  'value': 'megabytes',
                    'isRequired': true,
                    'description': 'Size unit can be set either in bytes, kilobytes, or megabytes (default). This configuration is not available in versions prior to Kong Enterprise 1.3 and Kong Gateway (OSS) 2.0'
                },
                  {
                      'displayName': 'Required Content length',
                      'parameter': 'require_content_length',
                      'type': 'boolean',
                      'value': false,
                      'isRequired': false,
                      'description': 'Set to true to ensure a valid Content-Length header exists before reading the request body'
                  }
              ]
            },
            {
              'displayName': 'Request Termination',
              'name': 'request-termination',
              'isConfigured': false,
              'img': '/assets/img/request-termination.png',
              'description': 'Configure Request termination service.',
              'tagline': 'This setting terminates incoming requests with a specified status code and message. This allows to (temporarily) stop traffic on a Service or a Route, or even block a Consumer',
              'config': [
                // {
                //   'parameter': 'consumerID',
                //   'type': 'string',
                //   'value': '',
                //   'description': 'The CONSUMER ID that this plugin configuration will target. This value can only be used if authentication has been enabled so that the system can identify the user making the request. If left blank, the plugin will be applied to all consumers.'
                // },
                {
                  'displayName': 'Status Code',
                  'parameter': 'status_code',
                  'type': 'number',
                  'value': 503,
                    'isRequired': false,
                  'description': 'The response code to send. Must be an integer between 100 and 599'
                },
                // {
                //     'displayName': 'Message',
                //   'parameter': 'message',
                //   'type': 'string',
                //   'value': '',
                //     'isRequired': false,
                //     'description': 'The message to send, if using the default response generator'
                // },
                {
                  'displayName': 'Content Type',
                  'parameter': 'content_type',
                  'type': 'string',
                  'value': 'application/json; charset=utf-8',
                    'isRequired': false,
                    'description': 'Content type of the raw response configured with config.body'
                },
                {
                  'displayName': 'Body',
                  'parameter': 'body',
                  'type': 'string',
                  'value': null,
                    'isRequired': false,
                    'description': 'The raw response body to send. This is mutually exclusive with the config.message field'
                }
              ]
            },
            // {
            //   'displayName': 'Response Rate Limiting',
            //   'name': 'response-ratelimiting',
            //   'isConfigured': false,
            //   'img': '/assets/img/response-ratelimiting.png',
            //   'description': 'Configure Response rate limiting service.',
            //   'tagline': 'This setting allows you to limit the number of requests a developer can make based on a custom response header returned by the upstream service. You can arbitrarily set as many rate-limiting objects (or quotas) as you want and instruct Kong to increase or decrease them by any number of units. Each custom rate-limiting object can limit the inbound requests per seconds, minutes, hours, days, months, or years',
            //   'config': [
            //     // {
            //     //   'parameter': 'consumerID',
            //     //   'type': 'string',
            //     //   'value': '',
            //     //   'description': 'The CONSUMER ID that this plugin configuration will target. This value can only be used if authentication has been enabled so that the system can identify the user making the request. If left blank, the plugin will be applied to all consumers.'
            //     // },
            //     {
            //       'displayName': 'Header Name',
            //       'parameter': 'header_name',
            //       'type': 'string',
            //         'isRequired': false,
            //       'value': 'X-Kong-Limit',
            //       'description': 'The name of the response header used to increment the counters'
            //     },
            //     {
            //       'displayName': 'Limit By',
            //       'parameter': 'limit_by',
            //       'type': 'string',
            //       'value': 'consumer',
            //         'isRequired': false,
            //         'description': 'The entity that will be used when aggregating the limits: consumer, credential, ip. If the consumer or the credential cannot be determined, the system will always fallback to ip'
            //     },
            //     {
            //       'displayName': 'Policy',
            //       'parameter': 'policy',
            //       'type': 'string',
            //       'value': 'local',
            //         'isRequired': false,
            //         'description': 'In DB-less and hybrid modes, the cluster config policy is not supported. For DB-less mode, use one of redis or local; for hybrid mode, use redis, or local for data planes only.\n' +
            //           '\n' +
            //           'In Konnect Cloud, the default policy is redis.'
            //     },
            //     {
            //       'displayName': 'Fault Tolerant',
            //       'parameter': 'fault_tolerant',
            //       'type': 'boolean',
            //       'value': true,
            //         'isRequired': true,
            //         'description': 'A boolean value that determines if the requests should be proxied even if Kong has troubles connecting a third-party datastore. If true, requests will be proxied anyway, effectively disabling the rate-limiting function until the datastore is working again. If false, then the clients will see 500 errors'
            //     },
            //     {
            //       'displayName': 'Redis Host',
            //       'parameter': 'redis_host',
            //       'type': 'string',
            //       'value': null,
            //         'isRequired': false,
            //         'description': 'When using the redis policy, this property specifies the address to the Redis server'
            //     },
            //     {
            //       'displayName': 'Redis Port',
            //       'parameter': 'redis_port',
            //       'type': 'number',
            //       'value': 6379,
            //         'isRequired': false,
            //         'description': 'When using the redis policy, this property specifies the port of the Redis server. By default is 6379.'
            //     },
            //     {
            //       'displayName': 'Redis Password',
            //       'parameter': 'redis_password',
            //       'type': 'string',
            //       'value': '',
            //         'isRequired': false,
            //         'description': 'When using the redis policy, this property specifies the password to connect to the Redis server'
            //     },
            //     // {
            //     //     'displayName': 'Redis Timeout',
            //     //   'parameter': 'Redis_timeout',
            //     //   'type': 'number',
            //     //   'value': 2000,
            //     //     'isRequired': false,
            //     //     'description': 'When using the redis policy, this property specifies the timeout in milliseconds of any command submitted to the Redis server'
            //     // },
            //     {
            //       'displayName': 'Redis Database',
            //       'parameter': 'redis_database',
            //       'type': 'number',
            //       'value': 0,
            //         'isRequired': false,
            //         'description': 'When using the redis policy, this property specifies Redis database to use'
            //     },
            //     {
            //       'displayName': 'Hide Client Headers',
            //       'parameter': 'hide_client_headers',
            //       'type': 'boolean',
            //       'value': false,
            //         'isRequired': true,
            //       'description': 'Optionally hide informative response headers'
            //     },
            //     {
            //       'displayName': 'Block On First Violation',
            //       'parameter': 'block_on_first_violation',
            //       'type': 'boolean',
            //       'value': false,
            //         'isRequired': true,
            //         'description': 'A boolean value that determines if the requests should be blocked as soon as one limit is being exceeded. This will block requests that are supposed to consume other limits too'
            //     }
            //   ]
            // }
          ]
        }
      ]
    }
  ];

  showCategory(category) {
    this.initialWindow = false;
    this.secondWindow = true;
    this.thirdWindow = false;
    this.categoryToShow = category;
  }

  showConfigurations(pluginName) {
    this.initialWindow = false;
    this.secondWindow = false;
    this.thirdWindow = true;
    this.pluginConfigurationsToShow = pluginName;
  }

  ngOnInit() {
  }

}
